import { NavLink } from 'react-router-dom';
import AnalysisGrid from './AnalysisGrid'; // 실제 내용 컴포넌트

function Analysis() {
  return (
    <div >
          <AnalysisGrid /> {/* 세금계산서 현황 그리드 내용 */}
    </div>
  );
}

export default Analysis;